import React from "react";
import Layout from "../../component/Layout";
import productDetail from "../../images/productDetail.png";
import { Link } from "react-router-dom";

const ToolDetail = () => {
  return (
    <Layout>
      <div className="bg-[#F6F6F6] h-fit">
        <div className="p-5 w-full max-w-2xl mx-auto h-fit">
          <div className="bg-white h-[353px] w-full max-w-[353px] p-[18px_43px_55px] rounded-[15px] mx-auto relative">
            <div className="h-[260px] w-full max-w-[260px] flex justify-center items-center">
              <img
                src={productDetail}
                alt="productDetail"
                className="object-cover"
              />
              <Link to="/tools" className="absolute top-5 left-5">
                <ArrowL />
              </Link>
            </div>
          </div>
          <div className="mt-4">
            <div className="mb-4">
              <p className="text-black text-xl font-normal">Product Title </p>
              <p className="text-black text-xl font-normal">$49.99</p>
            </div>
            <p className="text-black text-base font-normal">
              Lorem ipsum dolor sit amet consectetur. Bibendum nunc posuere
              cursus blandit. Ultricies sed leo sed dolor. Donec donec ipsum
              fringilla cursus lacus enim cursus viverra faucibus. Tempor dictum
              sit volutpat tincidunt eu sed aliquam. Eget eget odio varius a sed
              nunc ornare tincidunt dignissim.
            </p>
          </div>
          <div className="w-full mx-w-lg mt-[71px]">
            <button className="p-6 border border-black text-base font-semibold hover:opacity-70  rounded-[70px] w-full">
              Access Now
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ToolDetail;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
